import RemoveRepository from "@domain/repositories/RemoveRepository";
import UseCase from "@domain/UseCase";
import { RemoveHistory } from "@domain/models/RemoveHistory";

type Input = void;

type Output = Promise<RemoveHistory[]>;

export class GetRemoveHistoryUseCase implements UseCase<Input, Output> {
  constructor(private readonly removeRepository: RemoveRepository) {}

  execute() {
    return this.removeRepository.getRemoveHistory();
  }
}
